import { useEffect, useState } from 'react';
import { EMPTY_COUPONS, EMPTY_STRING_ARRAY, fetchGraphqlMaster } from '../api/graphql/master';
import { Master } from '../api/graphql/master/types';
import { fetchGraphqlPrevention } from '../api/graphql/prevention';
import { Prevention } from '../api/graphql/prevention/types';

/**
 *
 * @returns マスターデータ
 */
export const useMasterData = (): Master => {
  const [master, setMaster] = useState<Master | null>(null);

  useEffect(() => {
    (async () => await fetchGraphqlMaster().then(setMaster))();
  }, []);

  return (
    master ?? {
      categories: null,
      recommendedSets: null,
      settings: null,
      distributeCoupons: EMPTY_COUPONS,
      excludeDates: EMPTY_STRING_ARRAY,
      boxSettings: null,
    }
  );
};

/**
 * 特定のクエリを使用してメタオブジェクトを取得するカスタムフック
 * @param query 任意のGraphQLクエリ
 * @returns メタオブジェクトのデータ
 */
export const usePreventionData = (typename: string) => {
  const [preventionList, setPreventionList] = useState<Prevention[]>([]);

  useEffect(() => {
    (async () => await fetchGraphqlPrevention(typename).then(setPreventionList))();
  }, [typename]);

  return {
    preventionList,
  };
};
